import type { DocumentStructureFileItem, Tables } from "@msuite/utils/types";
import { useImperativeHandle } from "react";
import { Checkbox } from "../../checkbox";
import { useFileExplorerContext } from "./context";

/** Props Interface */
interface FileExplorerFileCheckboxProps<T extends { file: Tables<"files"> }> {
	item: DocumentStructureFileItem<T>;
	imperativeRef: React.RefObject<{
		toggleCheckbox: () => void;
	}>;
}

export function FileExplorerFileCheckbox<T extends { file: Tables<"files"> }>({
	item,
	imperativeRef,
}: FileExplorerFileCheckboxProps<T>) {
	/** Context */
	const { selectedFiles, setSelectedFiles } = useFileExplorerContext();

	/** Computed */
	const isChecked = selectedFiles.includes(item.file.id);

	/** Functions */
	function handleOnCheckboxToggle() {
		if (isChecked) {
			setSelectedFiles(selectedFiles.filter((fileId) => fileId !== item.file.id));
		} else {
			setSelectedFiles([...selectedFiles, item.file.id]);
		}
	}

	/** Hooks */
	useImperativeHandle(imperativeRef, () => ({
		toggleCheckbox: handleOnCheckboxToggle,
	}));

	/** Render */
	return (
		<Checkbox
			value={isChecked}
			onChange={handleOnCheckboxToggle}
		/>
	);
}
